import { InvalidArgumentError, Option } from 'commander';
import type { CommandInitFunction } from '../../types/CommandInitFunction.js';
import type { BundleOptions } from './types/BundleOptions.js';
import { reusedOptions } from '../../utilities/reusedOptions.js';

/** Defines the "bundle" verb. */
export const init: CommandInitFunction = (program) => {
  program.addSubCommand<BundleOptions>({
    name: 'bundle',
    description: 'Bundle one or more packages. It will bundle the current package unless --match is specified.',
    options: {
      match: reusedOptions.match('Bundle specific package(s)'),
      mode: reusedOptions.mode({ action: 'bundle' }),
      bundler: reusedOptions.bundler(),
      package: new Option('--package <package>').hideHelp().argParser(() => {
        throw new InvalidArgumentError('Use --match instead of --package');
      }),
      outdir: new Option(
        '--outdir <path>',
        'Path for the bundle output, relative to current path (or the resolved path to --match if specified). ' +
          'Default is a path under the cloudpack cache.',
      ),
      disableSourceMaps: new Option('--disable-source-maps', 'Disable source maps.'),
      logBundleInfo: reusedOptions.logBundleInfo(),
    },
    getExecutor: () => import('./execute.js'),
  });
};
